import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
}
export function TestimonialCard({
  quote,
  author,
  role
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 flex flex-col h-full" data-id="element-216">
      <div className="flex gap-1 mb-4" data-id="element-217">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-218" />)}
      </div>
      <p className="text-gray-700 text-lg italic mb-6 flex-grow" data-id="element-219">"{quote}"</p>
      <div className="mt-auto border-t pt-4 border-gray-100" data-id="element-220">
        <p className="font-bold text-gray-900" data-id="element-221">{author}</p>
        <p className="text-sm text-gray-500" data-id="element-222">{role}</p>
      </div>
    </div>;
}